import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import WhySection from '@/pages/home/components/WhySection';
import ArticleCards from '@/pages/home/components/ArticleCards';
import Testimonials from '@/pages/home/components/Testimonials';
import CTASection from '@/pages/home/components/CTASection';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL;

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Kakobuy Finds',
    url: siteUrl,
    description: 'Discover the ultimate Kakobuy Spreadsheet resource with 500+ best finds across 14 product categories. Organized shopping guides, product comparisons, and verified shopping lists updated weekly.',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrl}/?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Kakobuy Finds',
    url: siteUrl,
    logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png',
    sameAs: ['https://kaspreadsheet.com'],
    description: 'Your trusted resource for Kakobuy spreadsheet guides, product research, and smarter shopping intelligence.',
  };

  return (
    <main>
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <WhySection />
      <ArticleCards />
      <Testimonials />
      <CTASection />
      <Footer />
    </main>
  );
}